import { render, staticRenderFns } from "./InvoiceSettings.vue?vue&type=template&id=7b5235f8"
import script from "./InvoiceSettings.vue?vue&type=script&lang=js"
export * from "./InvoiceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports